import type { MaintenanceStatus } from '@/modules/maintenance/types/maintenance';

const ALLOWED: Record<MaintenanceStatus, readonly MaintenanceStatus[]> = {
  scheduled: ['in_progress', 'cancelled'],
  in_progress: ['completed'],
  completed: [],
  cancelled: [],
};

export function assertMaintenanceTransition(
  from: MaintenanceStatus,
  to: MaintenanceStatus,
): void {
  if (from === to) return;
  if (!ALLOWED[from].includes(to)) {
    throw new Error(
      `No se puede cambiar el estado de "${from}" a "${to}".`,
    );
  }
}

export function isBlockingMaintenanceStatus(
  status: MaintenanceStatus,
): boolean {
  return status === 'scheduled' || status === 'in_progress';
}
